import { queryOptions } from '@tanstack/react-query'
import {
  type GetAssetCategoriesOrder,
  get24hMarketCapChange,
  getAssetCategories,
  getFearAndGreedIndex,
} from '@/src/services/market-trends'

const MARKET_TRENDS_ROOT_QUERY_KEY = 'market-trends' as const

export const getFearAndGreedIndexQuery = () =>
  queryOptions({
    queryKey: [MARKET_TRENDS_ROOT_QUERY_KEY, 'fear-and-greed-index'],
    queryFn: () => getFearAndGreedIndex(),
    // Aligned with backend cache: 30min (app/integrations/coinmarketcap/provider.go:115 - fearGreedCache)
    staleTime: 1000 * 60 * 30, // 30 minutes
  })

export const get24hMarketCapChangeQuery = () =>
  queryOptions({
    queryKey: [MARKET_TRENDS_ROOT_QUERY_KEY, '24h-market-cap-change'],
    queryFn: () => get24hMarketCapChange(),
    // Aligned with backend cache: 10min (app/integrations/coingecko/provider.go:257 - globalDataCache)
    staleTime: 1000 * 60 * 10, // 10 minutes
  })

export const getAssetCategoriesQuery = (order?: GetAssetCategoriesOrder) =>
  queryOptions({
    queryKey: [MARKET_TRENDS_ROOT_QUERY_KEY, 'asset-categories', order],
    queryFn: () => getAssetCategories(order),
    // Aligned with backend cache: 10min (app/integrations/coingecko/provider.go:259 - categoriesWithMarketDataDataCache)
    staleTime: 1000 * 60 * 10, // 10 minutes
  })
